import React from "react";
import { Outlet } from "react-router-dom";
import AppNav from "@/components/AppNav";
import { TooltipProvider } from "@/components/ui/tooltip";
import { VercelThemeProvider } from "@/components/admin/VercelThemeProvider";
import GlobalToaster from "@/components/GlobalToaster";
import { CookieConsentBanner } from "@/components/shared/CookieConsentBanner";

interface AppLayoutProps {
  user?: {
    name: string;
    account_id?: string;
    avatar_url?: string | null;
    unread?: number;
    points?: number;
    checked_in?: boolean;
  } | null;
}

/**
 * 前台应用布局组件
 * - 包含导航栏
 * - 主内容区域
 * - 响应式布局
 * - 支持亮色/暗色主题切换
 *
 * 注意：Footer 只在首页显示，不包含在全局布局中
 */
export default function AppLayout({ user }: AppLayoutProps) {
  return (
    <VercelThemeProvider defaultTheme="dark" storageKey="app-theme">
      <TooltipProvider>
        <GlobalToaster />
        <div className="min-h-screen bg-background text-foreground flex flex-col">
          {/* 导航栏 */}
          <AppNav user={user} />

          {/* 主内容区 */}
          <main className="flex-1 w-full">
            <Outlet />
          </main>

          {/* Cookie 同意横幅 - 仅国际版显示 */}
          <CookieConsentBanner />
        </div>
      </TooltipProvider>
    </VercelThemeProvider>
  );
}
